import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 32px var(--theme-space-padding-button-sm) 32px;
  background-color: var(--theme-colors-global-grey-grey100);
`

const Text = styled.h5`
  font: var(--theme-typography-h5-semiBold);
`

export const s = { Wrapper, Text }
